// extracted by mini-css-extract-plugin
export default {"amenitySingleWord":"styles-module--amenitySingleWord--WBj9o"};